import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-16 w-full rounded-4 border border-line-strong bg-surface px-3 py-2 text-sm text-ink-900 transition-colors outline-none",
        "placeholder:text-ink-400",
        "focus-visible:border-p-600 focus-visible:ring-2 focus-visible:ring-p-100",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "aria-invalid:border-vroom-red aria-invalid:ring-2 aria-invalid:ring-vroom-red-soft",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
